import React from "react";
import "./Whatsapp.css";

const WhatsAppButton = () => {
  return (
    <></>
  );
};

export default WhatsAppButton;